<template>
  <div class="Results" v-if="Results_show">
        <div class="Results_top">
                <van-icon name="arrow-left" @click="fh_arrow"/>
                <p>湖南教招考试笔试题型</p>
                <img src="@/assets/img/logo_01.png" @click="logo_click"/>
        </div>
      
        <div class="Results_body">
            <div class="Results_body_top">
                <div class="Results_body_top_left">
                    您查询的学科是：<span>{{ subject_name }}</span>
                </div>
                <div class="Results_body_top_right" @click="area_visiblsess">
                    <img src="@/assets/img/results_01.png" />
                    <p>{{ area_name }}</p>
                </div>
            </div>

            <transition name="van-slide-down">
                <div v-show="area_visible" class="area_visible">
                    <span class="area_visible_item" v-for="item in area_list" :key="item.id" :class="area_id == item.id ? 'area_visible_item_active ' : ''" @click='area_visibles(item)'>{{ item.name }}</span>
                </div>
            </transition>

            <div class="Results_body_tab">
                <div class="Results_body_tab_list" >
                    <div ref="scrollItem" :id="'scrollItem' + item.id" v-for="(item,index) in county_list" :key='item.id' :class="item.id == district_and_county ? 'Results_body_tab_list_active' : ''" @click='Results_body_tab(item)'>{{ item.name }}</div>
                </div>
                <div class="Results_body_tab_right" @click="area_show = true">
                    <img src="@/assets/img/results_02.png" />
                </div>
            </div>

            <div class="Results_body_list">
                <div class="Results_body_list_top Results_body_list_item" v-for="(item,index) in data.data" :key="index">
                    <div class="Results_body_list_top_one" v-if="index == 0 && yearlist.length != 0">
                        <span>年份：</span>
                        <div class="Results_body_list_top_list">
                            <div class="Results_body_list_top_item" v-for="item in yearlist" :key='item' :class="year_id == item ? 'Results_body_list_top_item_active':''" @click="yearclick(item)">{{ item }}</div>
                        </div>
                    </div>

                    <div class="Results_body_list_top_two" v-if="item.recruit_type.length != 0 || item.learning_section.length != 0">
                        <div v-if="item.learning_section.length != 0" :style="{width: item.recruit_type.length == 0 ? '100%' : ''}">
                            <span>学段：</span>
                            <p>{{ item.learning_section }}</p>
                        </div>

                        <div v-if="item.recruit_type.length != 0" :style="{width: item.learning_section.length == 0 ? '100%' : ''}">
                            <span>招聘类别：</span>
                            <p> {{ item.recruit_type }}</p>
                        </div>
                    </div>

                    <div class="Results_body_list_top_two" v-if="item.difficulty.length != 0 || item.full_marks.length != 0">
                        <div v-if="item.difficulty.length != 0" :style="{width: item.full_marks.length == 0 ? '100%' : ''}">
                            <span>难度：</span>
                            <p>{{ item.difficulty }}</p>
                        </div>

                         <div v-if="item.full_marks.length != 0" :style="{width: item.difficulty.length == 0 ? '100%' : ''}">
                            <span>满分：</span>
                            <p> {{ item.full_marks }}</p>
                        </div>
                    </div>

                    <div class="Results_body_list_top_four" v-if="item.question_type.length != 0">
                        <div>
                            <span>题型：</span>
                            <pre v-html="item.question_type">
                            </pre>
                            <div @click="Results_jtu(item.id)"><img src="@/assets/img/results_03.png" />分享</div>
                        </div>
                    </div>

                    <div class="Results_body_list_top_four" v-if="item.extra.length != 0">
                        <div >
                            <span>备注：</span>
                            <p> {{ item.extra }}</p>
                        </div>
                    </div>

                    <div class="Results_body_list_top_threes" v-if="item.extra_id != 0" >
                        <button @click="thress_link(item)">点击查看笔试真题</button>
                    </div>
                </div>

                <a :href="'/m/productcentre?city=' + area_id + '&county=' + district_and_countys.split(',')[0]" class="Results_body_banner">
                    <div class="Results_body_button">{{ district_and_name }}</div>
                </a>
                <a href="/m/productcentre" class="Results_body_a">点击查看更多 <van-icon name="arrow" /></a>
            </div>
            <proposal :like='data.like' :api_token='api_token' :agency_id='agency_id' :is_like='data.is_like' :id = '0'/>
        </div>
         <!--  v-if="JSON.stringify(data_detail) != '{}'" && Results_shows == true -->
        <div class="Results_jtu" v-show="JSON.stringify(data_detail) != '{}' && Results_shows == true">
            <div class="Results_jtu_banner">
                <img class="banner_02" src="@/assets/img/banner_02.png" />
                <p class='title'>考教师就选新百易</p>
                <p>{{data_detail.particular_year}}{{data_detail.district}}{{data_detail.district_and_county}}</p>
                <img class="banner_01" src="@/assets/img/banner_01.png" />
            </div>

            <div class="Results_body_list_top_two" v-if="data_detail.district != null ||data_detail.district_and_county != null"> 
                <div  v-if="data_detail.district != null " :style="{width: data_detail.district != null && data_detail.district_and_county == null ? '100%' : ''}">
                    <span>地市：</span>
                    <p>{{data_detail.district}}</p>
                </div>

                <div v-if="data_detail.district_and_county != null " :style="{width:  data_detail.district_and_county != null && data_detail.district == null ? '100%' : ''}">
                    <span>区县：</span>
                    <p> {{data_detail.district_and_county}} </p>
                </div>
            </div>

            <div class="Results_body_list_top_two" v-if="data_detail.subject != null || data_detail.particular_year != null">
                <div  v-if="data_detail.subject != null " :style="{width: data_detail.subject != null && data_detail.particular_year == null ? '100%' : ''}">
                    <span>学科：</span>
                    <p>{{data_detail.subject}}</p>
                </div>

                <div v-if="data_detail.particular_year != null" :style="{width: data_detail.particular_year != null && data_detail.subject == null ? '100%' : ''}">
                    <span>年份：</span>
                    <p> {{data_detail.particular_year}} </p>
                </div>
            </div>

            <div class="Results_body_list_top_two" v-if="data_detail.learning_section != null || data_detail.recruit_type != null">
                <div v-if="data_detail.learning_section != null " :style="{width:data_detail.learning_section != null &&  data_detail.recruit_type == null ? '100%' : ''}">
                    <span>学段：</span>
                    <p>{{data_detail.learning_section}}</p>
                </div>

                <div v-if="data_detail.recruit_type != null " :style="{width:data_detail.recruit_type != null && data_detail.learning_section == null ? '100%' : ''}">
                    <span>招聘类别：</span>
                    <p> {{data_detail.recruit_type}} </p>
                </div>
            </div>

            <div class="Results_body_list_top_two"  v-if="data_detail.difficulty != null || data_detail.full_marks != null">
                <div v-if="data_detail.difficulty.length != 0" :style="{width: data_detail.full_marks == null  && data_detail.difficulty.length != 0 ? '100%' : ''}">
                    <span>难度：</span>
                    <p>{{data_detail.difficulty}}</p>
                </div>

                <div v-if="data_detail.full_marks != null" :style="{width: data_detail.difficulty.length == 0 && data_detail.full_marks != null ? '100%' : ''}">
                    <span>满分：</span>
                    <p> {{ data_detail.full_marks }}</p>
                </div>
            </div>

            <div class="Results_body_list_top_four" v-if="data_detail.question_type != null">
                <div>
                    <span>题型：</span>
                    <pre v-html="data_detail.question_type">
                    </pre>
                </div>
            </div>
            
            <div class="Results_body_list_lj">
                <div id="class_img" ref="qrCodeDiv" style="margin-top: 0;"></div>
                <!-- <img :src="'https://apinew.5kjs.com/activity.teaching_textpaper/getQrcode?share_url= '+ origin" alt=""> -->
                <p>长按扫码了解更多笔试题型</p>
            </div>

            <div class="Results_body_list_flex">
                <div class="Results_body_list_flex_left">
                    <img src="@/assets/img/code.jpg" alt="">
                    <span>想要获取更多教招资讯快来关注新百易公众号</span>
                </div>
                <span class="Results_body_list_flex_fie"></span>
                <div class="Results_body_list_flex_right">
                    <img src="@/assets/img/icon_05.png" alt="">
                    <span>新百易客服热线 {{  data_inof.phone != null ? data_inof.phone : '16673138137' }}</span>
                </div>
            </div>
        </div>
      
      <Bottom></Bottom>
    <van-popup v-model="imgtt_show" round  position="top" :style="{ width: '100%', background:'rgba(0,0,0,0)', height: '100%', overflow: 'scroll' }">
       <div style="width:100%;height:100%;overflow: scroll;padding-left:.5rem;padding-top:.22rem">
            <span class="area_cshu" @click="imgtt_show = false" v-if="imgtt_show"><van-icon name="cross" /></span>
            <img class="imgtt area_show" src="">
            <div class="area_tish">
                原来往年考的这些题型，长按保存图片至相册，分享给朋友一起看看吧
            </div>
       </div>
    </van-popup>
    
    <kfu />
    <van-popup v-model="area_show" round  position="right" :style="{ height: '100%' }" >
        <div class="popup_area">
            <div class="popup_area_top">
                <p>请选择区县</p>
                <van-icon name="cross" @click="area_show = false"/>
            </div>
            <div class="area_visible">
                <span class="area_visible_item" v-for="item in county_list" :key='item.id' :class="item.id == district_and_countys ? 'area_visible_item_active' : ''" @click='Results_body_tabs(item)'>{{ item.name }}</span>
            </div>
            <button @click="button_county">确 定</button>
        </div>
    </van-popup>
      
  </div>
</template>

<script>
  import login from '@/components/login/index.vue'
  import Bottom from '@/components/bottom/index.vue'
  import proposal from '@/components/proposal/index.vue'
  import kfu from '@/components/kfu/index.vue'
  export default {
    name: "Results",
    data() {
      return {
          logo: '',
          subject: '',
          subject_name:'',
          district_and_county: '',
          county_list: [],
          area_id: '',
          area_show: false,
          area_list: [],
          area_name: '',
          area_visible: false,
          district_and_countys:'',
          district_and_name: '',
          yearlist:[],
          year_id: '',
          data:[],
          imgtt_show: false,
          data_detail: {},
          origin:'',
          Results_show: false,
          Results_shows: false,
          data_inof: {},
      };
    },
    props:['api_token', 'agency_id'],
    created() {
        if(localStorage.getItem('subject') != null) {
          this.data_inof = JSON.parse(localStorage.getItem('data_inof'))
        }
        this.subject = this.$route.query.subject
        this.district_and_county = this.$route.query.district_and_county
        this.district_and_countys = this.$route.query.district_and_county
        this.area_id = this.$route.query.area_id
    },
    methods:{
        generateQRCode(value, width, height) {
            //先清空
            $('.Results_body_list_lj div').empty();
            //中文格式转换
            var str = this.toUtf8(value);
            console.log(str, $('.Results_body_list_lj div'))
            $(".Results_body_list_lj div").qrcode({
                render: "canvas",//canvas和table两种渲染方式
                width: width,
                height: height,
                text: str
            });
		},
        toUtf8(str) {
            var out, i, len, c;
            out = "";
            len = str.length;
            for (i = 0; i < len; i++) {
                c = str.charCodeAt(i);
                if ((c >= 0x0001) && (c <= 0x007F)) {
                    out += str.charAt(i);
                } else if (c > 0x07FF) {
                    out += String.fromCharCode(0xE0 | ((c >> 12) & 0x0F));
                    out += String.fromCharCode(0x80 | ((c >> 6) & 0x3F));
                    out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
                } else {
                    out += String.fromCharCode(0xC0 | ((c >> 6) & 0x1F));
                    out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
                }
            }
            return out;
        },
        yeadj() {
              localStorage.setItem('district_id', this.area_id)
              localStorage.setItem('district', this.area_name)
              localStorage.setItem('subject', this.subject_name)
              localStorage.setItem('subject_id', this.subject)
              localStorage.setItem('district_and_county_id', this.district_and_county)
              localStorage.setItem('district_and_county', this.district_and_name)
              localStorage.setItem('year', this.year_id)
        },
        area_visiblsess() {
            if(this.area_visible == false) {
                this.area_visible = true
            }else {
                this.area_visible = false
            }
        },
        //跳转详情页
        thress_link(val) {
            this.$router.push({path:'/detail?id=' + val.id})
        },
        //点击logo跳转
        logo_click() {
            window.location.href = '/'
        },
        //点击返回
        fh_arrow() {
            this.$router.push({path:'/'})
        },
        //点击生成图片
        Results_jtu(id) {
            this.origin = window.location.origin + '/activity/written/#/index'
            this.Results_shows = true
            this.generateQRCode(this.origin, 100, 100)
            const loading = this.$loading({
                lock: true,
                text: '图片生成中...',
                background: 'rgba(0, 0, 0, 1)'
            });
            setTimeout(()=>{
                this.$axios.get('getTextpaperShare', {params:{token: this.api_token,id: id }},).then((d)=> {
                    if(d.code == 200) {
                        this.data_detail = d.data
                        setTimeout(() => {
                            var than = this
                            than.imgtt_show = true
                            var height = $('.Results_jtu').outerHeight();
                            // $('.area_show').css('top', ($('html').outerHeight() - $('.Results_jtu').outerHeight()) / 2);
                            html2canvas(document.querySelector('.Results_jtu'), { x: $('body').left, y: $('body').top, useCORS: true, dpi: 300, scale: 8, }).then(canvas => {
                                $('.imgtt').attr('src', canvas.toDataURL());
                                $('.area_show').css('height', height);
                                loading.close();
                                this.Results_shows = false
                            });
                        }, 800);
                    }else {
                        this.$toast(d.message)
                    }
                }).catch((err) => {
                    // this.$toast(err)
                });
            }, 500)
        },
        //点击年份
        yearclick(val) {
            this.year_id = val
            this.query_now()
        },
        //获取年份
        yearList(i){
            this.$axios.get('yearList', {params:{token: this.api_token,subject:this.subject,district_and_county:this.district_and_county}},).then((d)=> {
                if(d.code == 200) {
                    this.yearlist = d.data
                    this.year_id = d.data[0]
                    if(i!=1) {
                        this.query_now()
                    }
                    this.yeadj()
                }else {
                    this.$toast(d.message)
                }
            }).catch((err) => {
                // this.$toast(err)
            });
        },
        //选择区县
        button_county() {
            this.area_show = false
            this.district_and_county = this.district_and_countys
            var scolrr = 'scrollItem' + this.district_and_county
            this.scroll(scolrr)
        },
        Results_body_tabs(val) {
            this.district_and_countys = val.id
        },
        // 滚动
        scroll(selector) {
            this.$nextTick(()=>{
                this.county_list.forEach(ite => {
                    if(ite.name.length > 3) {
                        document.getElementById('scrollItem' + ite.id).style.minWidth = '2.2rem'
                    }
                })
                document.getElementById(selector).scrollIntoView({behavior: 'smooth', block: 'center'});
            })
        },
        //点击区
        Results_body_tab(val) {
            this.district_and_county = val.id
            this.district_and_countys = val.id
            this.$router.push({path:'/results?subject=' + this.subject + '&district_and_county=' + this.district_and_county + '&area_id=' + this.area_id})
            // this.query_now()
            this.yearList()
        },
        //点击市
        area_visibles(val) {
            this.area_show = false
            this.area_id = val.id
            this.yearList()
            this.$router.push({path:'/results?subject=' + this.subject + '&district_and_county=' + this.district_and_county + '&area_id=' + this.area_id})
            this.areaList(1)
            // this.query_now()
        },
        //获取学科
        subjectList(){
            this.$axios.get('subjectList', {params:{token: this.api_token}},).then((d)=> {
            if(d.code == 200) {
                d.data.forEach(item => {
                    if(item.id == this.subject) {
                        this.subject_name = item.name
                    }
                });
            }else {
                this.$toast(d.message)
            }
            }).catch((err) => {
                // this.$toast(err)
            });
        },
         //获取区县内容
        areaList(i){
            var than = this
            this.$axios.get('areaList', {params:{subject:this.subject,token:this.api_token}},).then((d)=> {
                if(d.code == 200) {
                    this.Results_show = true
                    this.area_list = d.data
                    this.area_list.forEach(item=> {
                        if(item.id == this.area_id) {
                            this.area_name = item.name
                            this.county_list = item.county
                            if(i == 1) {
                                this.district_and_county = this.county_list[0].id
                                this.district_and_countys = this.county_list[0].id
                                this.$router.push({path:'/results?subject=' + this.subject + '&district_and_county=' + this.district_and_county + '&area_id=' + this.area_id})
                            }
                           
                            if(i != 1) {
                                var scolrr = 'scrollItem' + this.district_and_county
                                setTimeout(function() {
                                    than.scroll(scolrr)
                                },100)
                            }
                        }
                    })
                    this.query_now()
                }else {
                    this.$toast(d.message)
                }
            }).catch((err) => {
                // this.$toast(err)
            });
        },
        //点击立即查询
        query_now() {
            this.county_list.forEach(item=>{
                if(item.id == this.district_and_county) {
                    this.district_and_name = item.name
                }
            })
            const loading = this.$loading({
                lock: true,
                text: '加载中...',
                background: 'rgba(0, 0, 0, 1)'
            });
            this.yeadj()
            this.$axios.get('getTextpaperList', {params:{
                subject:this.subject,
                token:this.api_token, 
                district_and_county:this.district_and_county, 
                agency_id: this.agency_id,
                year:this.year_id,
                limt: 10,
                page: 1
             }},).then((d)=> {
                loading.close();
                if(d.code == 200) {
                    this.logo = localStorage.getItem('path')
                    this.data = d.data
                }else if(d.code == 202) {
                    this.$router.push({path:'/'})
                }else {
                    this.$toast(d.message)
                }
            })
        },
    },
    mounted() {
        var than = this
        this.subjectList()
        this.yearList(1)
        this.areaList()
    },
    components: {
      login,Bottom,proposal,kfu
    },
  };
</script>

<style lang="less" scoped>

.Results_jtu >  .Results_body_list_flex  > .Results_body_list_flex_right  span{
    width: 2rem !important;
}

.Results_jtu > .Results_jtu_banner {
    position: relative;
}

.Results_jtu > .Results_jtu_banner > .banner_01 {
    position: absolute;
    width: 5.2rem;
    left: 0;
    right: 0;
    margin: auto;
    bottom: .3rem;
}

.Results_jtu > .Results_jtu_banner > .banner_02 {
    position: absolute;
    width: 2rem;
    left: 0;
    top: 0;
}

.Results_jtu > .Results_jtu_banner > .title {
    position: absolute;
    width: 5rem;
    left: 0;
    right: 0;
    margin: auto;
    font-weight: 400;
    font-size: .24rem;
    top: .7rem;

}

.Results_jtu > .Results_jtu_banner > .title::after {
    content: '';
    display: block;
    position: absolute;
    width: .4rem;
    background: #FFF;
    height: 1px;
    right: .6rem;
    top: 0;
    bottom: 0;
    margin: auto;
}

.Results_jtu > .Results_jtu_banner > .title::before {
    content: '';
    display: block;
    position: absolute;
    width: .4rem;
    background: #FFF;
    height: 1px;
    left: .6rem;
    top: 0;
    bottom: 0;
    margin: auto;
}

.van-toast  {
    width: 2rem !important;
}
.Results_body{
    background: #FFF;
}
.Results_top {
    widows: 7.5rem;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    margin: auto;
    height: .8rem;
    display: flex;
    align-items: center;
    padding-left: .3rem;
    padding-right: .3rem;
    z-index: 10;
    background: #FFF;
    border-bottom: 1px solid #F1F1F1;
    > i {
        font-size: .41rem;
    }

    > p {
        width: 5.17rem;
        font-size: 0.32rem;
        font-weight: 500;
        color: #000000;
        overflow:hidden;
        white-space: nowrap;
        text-overflow:ellipsis;
        white-space:nowrap;
        margin-left: .55rem;
    }

    > img {
        height: .48rem;
    }
}

.area_visible {
    padding: .31rem;
    padding-top: 0;
    display: flex;
    flex-wrap: wrap;
    .area_visible_item {
        padding: 0 .36rem;
        height: 0.6rem;
        line-height: .6rem;
        background: #F2F2F5;
        border-radius: 0.08rem;
        font-size: 0.26rem;
        font-family: PingFang SC;
        color: #7E858A;
        margin-right: .13rem;
        margin-bottom: .33rem;
    }

    .area_visible_item_active {
        color: #FF774E;
        background: #FFF7F4;
    }
}

.Results_body {
    padding-bottom: 1.5rem;
    padding-top: .9rem;
    .Results_body_top {
        display: flex;
        widows: 7.5rem;
        padding: .2rem .26rem;
        justify-content: space-between;
        .Results_body_top_left {
            display: flex;
            align-items: center;
            font-size: 0.3rem;
            font-weight: 500;
            color: #333333;
            line-height: 0.71rem;
            > span {
                color: #FF774E;
            }
        }

        .Results_body_top_right {
            display: flex;
            align-items: center;
            > img {
                height: .29rem;
            }

            > p {
                min-width: 1.2rem;
                font-size: 0.26rem;
                font-family: PingFang SC;
                font-weight: 500;
                color: #FF774E;
                line-height: 0.71rem;
                margin-left: .1rem;
                position: relative;
                z-index: 4;
                &::after {
                    content: '';
                    display: block;
                    width: .8rem;
                    height: 0.06rem;
                    background: #FFE6DF;
                    position: absolute;
                    bottom: .18rem;
                    opacity: .5;
                }
            }
        }
    }

   
    .Results_body_tab {
        position: relative;
        border-top: 1px solid #F1F1F1;
        overflow: hidden;
        box-shadow: 0rem 2px 4px rgba(0, 0, 0, 0.06);
        .Results_body_tab_list {
            width: 6.52rem;
            overflow-x: scroll;
            display: flex;
            &::-webkit-scrollbar {
                display: none;
            }
            > div　{
                min-width: 1.5rem;
                height: .96rem;
                font-size: 0.3rem;
                font-family: PingFang SC;
                color: #9EA5AB;
                line-height: .96rem;
                text-align: center;
                position: relative;
            }
            > .Results_body_tab_list_active {
                color: #374049;
                font-size: .34rem;
                font-weight: 600;
                 &::after {
                    content: '';
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    left: 0;
                    margin: auto;
                    width: 0.22rem;
                    height: 0.06rem;
                    background: linear-gradient(90deg, #FA7368, #EC5448);
                    border-radius: 0.03rem;
                }
            }
        }
        
        .Results_body_tab_right {
            width: 0.98rem;
            height: 0.96rem;
            background: #FFFFFF;
            position: absolute;
            display: flex;
            top: 0;
            right: 0;
            justify-content: center;
            align-items: center;
            box-shadow: -20px 0 20px rgba(0, 0, 0, 0.06);
            img {
                height: .28rem;
            }
        }
    }

    .Results_body_list {
        width: 6.89rem;
        margin: 0 auto;
        margin-top: .3rem;
        margin-bottom: .3rem;
        padding-bottom: .42rem;
        // border-radius: 20px;
        // box-shadow: 0rem 0rem 10px rgba(54, 54, 54, 0.1);
        .Results_body_list_item {
            border-radius: 20px;
            box-shadow: 0rem 0rem 10px rgba(54, 54, 54, 0.1);
            margin-bottom: .35rem;
            > div:last-child {
                border-bottom: none;
            }
        }
        .Results_body_list_top {
               > .Results_body_list_top_one {
                display: flex;
                align-items: center;
                padding: .21rem .31rem;
                background: #FFF;
                width: 100%;
                overflow-x: scroll;
                border-bottom: 1px solid #E3E3E3;
                > span {
                    font-size: 0.28rem;
                    font-weight: 500;
                    color: #9F9F9F;
                }

                .Results_body_list_top_list {
                    display: flex;
                    max-width: 80%;

                    .Results_body_list_top_item {
                        padding: 0 .33rem;
                        height: 0.63rem;
                        box-shadow: 0rem 0rem 20px rgba(191, 16, 0, 0.23);
                        border-radius: 0.32rem; 
                        font-size: 0.28rem;
                        font-family: PingFang SC;
                        color: #9D9D9D;
                        line-height: 0.63rem;
                        margin-right: .2rem;
                    }

                    .Results_body_list_top_item_active {
                        background: #FF774E;
                        color: #FFF;
                    }
                }
            }
            > div {
                p {
                }
            }
            .Results_body_list_top_two {
                display: flex;
                justify-content: space-between;
                border-bottom: 1px solid #E3E3E3;
                > div {
                    width: 50%;
                    display: flex;
                    align-items: center;
                    padding: .21rem 0;
                    &:nth-child(2) {
                        border-left: 1px solid #E3E3E3;
                    }
                     > span {
                        font-size: 0.28rem;
                        font-weight: 500;
                        color: #9F9F9F;
                        text-align: center;
                        margin-left: .31rem;
                    }

                    > p {
                        width: 1.5rem;
                        font-size: 0.28rem;
                        font-weight: 500;
                        color: #302E32;
                    }
                }
            }

            .Results_body_list_top_three {
                border-bottom: 1px solid #E3E3E3;
                > div {
                    display: flex;
                    align-items: center;
                    padding: .21rem 0;
                     > span {
                        font-size: 0.28rem;
                        font-weight: 500;
                        color: #9F9F9F;
                        text-align: center;
                        margin-left: .31rem;
                    }

                    > p {
                        width: 5rem;
                        font-size: 0.28rem;
                        font-weight: 500;
                        color: #302E32;
                    }
                }
            }

            .Results_body_list_top_four {
                border-bottom: 1px solid #E3E3E3;
                 > div {
                    display: flex;
                    // align-items: center;
                    padding: .21rem 0;
                    position: relative;
                     > span {
                        font-size: 0.28rem;
                        font-weight: 500;
                        color: #9F9F9F;
                        text-align: center;
                        margin-left: .31rem;
                    }

                    >pre {
                        width: 4.5rem;
                        font-size: 0.28rem;
                        font-weight: 500;
                        color: #302E32;
                        font-family: -apple-system,BlinkMacSystemFont,'Helvetica Neue',Helvetica,Segoe UI,Arial,Roboto,'PingFang SC',miui,'Hiragino Sans GB','Microsoft Yahei',sans-serif;
                        white-space: pre-wrap;
                        margin: 0;
                    }

                    > p {
                        width: 4.5rem;
                        font-size: 0.28rem;
                        font-weight: 500;
                        color: #302E32;
                    }

                    > div {
                        position: absolute;
                        right: 0px;
                        top: .18rem;
                        width: 1.16rem;
                        border-radius: 0.4rem 0 0  .4rem;
                        height: 0.51rem;
                        background: #FFFFFF;
                        box-shadow: 0rem 0rem 10px rgba(0, 0, 0, 0.2);
                        display: flex;
                        align-items: center;
                        font-size: 0.22rem;
                        font-family: PingFang SC;
                        justify-content: center;
                        color: #222222;
                        > img {
                            height: .22rem;
                            margin-right: .1rem;
                            margin-top: .01rem;
                        } 
                    }
                }
            }

            .Results_body_list_top_threes {
                display: flex;
                align-items: center;
                justify-content: center;
                padding: .21rem 0;
                border-bottom: 1px solid #E3E3E3;
                > button {
                    width: 5.25rem;
                    height: 0.7rem;
                    border: none;
                    background: linear-gradient(90deg, #FD9366, #FF734A);
                    border-radius: 0.35rem;
                    font-size: 0.32rem;
                    text-align: center;
                    font-family: PingFang SC;
                    color: #FFFFFF;
                }
            }
        
        }

        .Results_body_banner {
            width: 6.67rem;
            height: 2.17rem;
            display: block;
            border-radius: 0.1rem;
            background: url('../../assets/img/results_04.png') center center no-repeat;
            background-size: 100% 100%;
            margin: 0 auto;
            margin-top: .42rem;
            overflow: hidden;
            .Results_body_button {
                height: .46rem;
                background: #FFFFFF;
                border-radius: 0.23rem;
                font-size: 0.29rem;
                font-weight: 400;
                color: #FB5116;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 0 .3rem ;
                text-align: center;
                position: relative;
                max-width: 2.4rem;
                margin-top: .48rem;
                text-align: center;
                margin-left: .27rem;
                &::after{
                    content: '';
                    width: 4px;
                    height: 4px;
                    display: flex;
                    background: #FB5116;
                    border-radius: 100%;
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    left: .2rem;
                    margin: auto;
                }
                &::before{
                    content: '';
                    width: 4px;
                    height: 4px;
                    display: flex;
                    background: #FB5116;
                    border-radius: 100%;
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    right: .2rem;
                    margin: auto;
                }
            }

            > p {
                font-size: 0.44rem;
                font-family: AlibabaPuHuiTi_2_115_Black;
                font-weight: 400;
                color: #FFFFFF;
                text-shadow: 0rem 0rem 10px rgba(251, 47, 0, 0.6);
                margin-left: .27rem;
                margin-top: .31rem;
            }
        }
    }

    .Results_body_a {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.3rem;
        text-align: center;
        color: #FF774E;
        margin-top: .58rem;
        > i {
            margin-top: .05rem;
            margin-left: .05rem;
        }
    }
}

.popup_area {
    width: 6rem;
    padding-top: .2rem;
    .area_visible {
        flex-wrap: wrap; 
        .area_visible_item {
            margin-right: .29rem;
        }
    }
    .popup_area_top {
        padding: 0.31rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        > p {
            font-size: 0.28rem;
            font-family: PingFang SC;
            font-weight: bold;
            color: #141414;
            margin: 0;
        }

        > i {
            font-size: .37rem;
        }
    }

    > button {
        width: 4.62rem;
        height: 0.7rem;
        background: #FF774E;
        box-shadow: 0rem 0rem 10px rgba(191, 16, 0, 0.23);
        border-radius: 0.35rem;
        margin: 0 auto;
        display: block;
        font-size: 0.3rem;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 0.7rem;
        border: none;
    }
}

.Results_jtu {
    width: 6.42rem;
    background: #FFF;
    position: fixed;
    z-index: 2;
    top: 0;
    border-radius: .4rem;
    position: fixed;
    z-index: -1;
    &::after {
        content: '';
        position: absolute;
        right: 0;
        left: 0;
        bottom: 0;
        top: 0;
        margin: auto;
        background: url('../../assets/img/logo_si.png') center center no-repeat;
        background-size: 7rem 2rem;
        transform: rotate(-20deg);
    }
    .Results_jtu_banner {
        width: 6.42rem;
        height: 3.12rem;
        opacity: 1;
        background: url('../../assets/img/results_banner.png') 50% no-repeat;
        background-size: 6.42rem 3.12rem;
        padding-top: 1.3rem;
        > p {
            width: 5.38rem;
            margin: 0 auto;
            font-size: 0.44rem;
            font-family: PingFang SC;
            font-weight: bold;
            color: #FFFFFF;
            text-align: center;
            text-shadow: 0rem 0rem 10px rgba(223, 108, 53, 0.4);
        }
    }

    .Results_body_list_top_two {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #E3E3E3;
        background: #FFF;
        > div {
            width: 50%;
            display: flex;
            align-items: center;
            padding: .21rem 0;
            &:nth-child(1) {
                border-right: 1px solid #E3E3E3;
            }
                > span {
                font-size: 0.28rem;
                font-weight: 500;
                color: #9F9F9F;
                text-align: center;
                margin-left: .31rem;
            }

            > p {
                width: 1.2rem;
                font-size: 0.28rem;
                font-weight: 500;
                color: #302E32;
            }
        }
    }

    .Results_body_list_top_four {
        border-bottom: 1px solid #E3E3E3;
        background: #FFF;
            > div {
            display: flex;
            align-items: center;
            padding: .21rem 0;
            position: relative;
                > span {
                font-size: 0.28rem;
                font-weight: 500;
                color: #9F9F9F;
                text-align: center;
                margin-left: .31rem;
            }

            > pre {
                  font-family: -apple-system,BlinkMacSystemFont,'Helvetica Neue',Helvetica,Segoe UI,Arial,Roboto,'PingFang SC',miui,'Hiragino Sans GB','Microsoft Yahei',sans-serif;
                width: 4.5rem;
                font-size: 0.28rem;
                font-weight: 500;
                color: #302E32;
                white-space: pre-wrap;
            }

            > p {
                width: 4.5rem;
                font-size: 0.28rem;
                font-weight: 500;
                color: #302E32;
            }

            > div {
                position: absolute;
                right: 0px;
                top: .18rem;
                width: 1.16rem;
                border-radius: 0.2rem 0 0  .2rem;
                height: 0.51rem;
                background: #FFFFFF;
                box-shadow: 0rem 0rem 10px rgba(0, 0, 0, 0.2);
                display: flex;
                align-items: center;
                font-size: 0.22rem;
                font-family: PingFang SC;
                justify-content: center;
                color: #222222;
                > img {
                    height: .22rem;
                    margin-right: .1rem;
                    margin-top: .01rem;
                } 
            }
        }
    }

    .Results_body_list_lj {
        background: #FFF;
        padding-top: .34rem;
        padding-bottom: .36rem;
        img,div {
            background: #FFF;
            width: 1.74rem;
            height: 1.75rem;
            display: block;
            margin: 0 auto;
            margin-top: 0;

            
        }

        > p {
            background: #FFF;
            font-size: 0.28rem;
            font-family: PingFang SC;
            color: #302E32;
            margin-top: .32rem;
            text-align: center;
        }
    }

    .Results_body_list_flex {
        display: flex;
        border-top: 1px solid #E3E3E3;
        position: relative;
        align-items: center;
        background: #FFF;
        height: 1.14rem;
        .Results_body_list_flex_fie{
            width: 1px;
            height: 0.82rem;
            position: absolute;
            right: 0;
            top: 0;
            bottom: 0;
            left: .6rem;
            margin: auto;
            background: #EAEAEA;
        }
        .Results_body_list_flex_left {
            display: flex;
            align-items: center;
            justify-content: center;
            > img {
                width: 0.48rem;
                height: 0.48rem;
                margin-left: .2rem;
            }

            > span {
                width: 2.6rem;
                font-size: 0.2rem;
                font-weight: 500;
                color: #302E32;
                margin-left: .2rem;
            }
        }

        .Results_body_list_flex_right {
            display: flex;
            align-items: center;
            justify-content: center;
            > img {
                width: 0.38rem;
                height: 0.38rem;
                margin-left: .2rem;
            }

            > span {
                width: 2.6rem;
                font-size: 0.2rem;
                font-weight: 500;
                color: #302E32;
                margin-left: .2rem;
            }
        }
    }
}

.area_show {
    width: 6.42rem;
    height: 11.6rem;
    position: relative;
    background: #FFF;
    border-radius: .2rem;
}

.area_cshu {
    width: 0.53rem;
    height: 0.53rem;
    position: absolute;
    top: .1rem;
    right: .3rem;
    z-index: 3000;
    background: #FFFFFF;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    > i {
        font-size: .3rem;
    }
}

.area_tish {
    width: 6.42rem;
    padding: .1rem .2rem;
    font-size: 0.24rem;
    background: rgba(255, 255, 255, .14);
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    margin: auto;
    margin-left: 0;
    bottom: 0rem;
    z-index: 3000;
    margin-top: .3rem;
    border-radius: .1rem;
    position: relative;
    margin-bottom: 100px;
    &::after {
        content: '';
        display: block;
        position: absolute;
        top: -.26rem;
        width: 0;
        height: 0;
        border:10px solid transparent;
        border-bottom-color:rgba(255, 255, 255, .14);

    }
}

</style>
